window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  const frequencyApiPattern = /https:\/\/shapi\.bundlepayments\.com\/customers\/(\d+)\/subscriptions\/(\d+)\/frequency/;
  let capturedAuthToken = null;

  const handleFrequencyApiCall = (customerId, subscriptionId, response, authToken) => {
    capturedAuthToken = authToken;
    console.log("Frequency API intercepted:", {
      customerId,
      subscriptionId,
      response
    });

    if (response && response.BillingIntervalBillingCount) {
      const interval = response.BillingIntervalBillingCount;
      const [type, value] = interval.split("#");
      const count = parseInt(value);

      const completedAt = window.Awtomic?.subscriptionBillingAttempts?.[0]?.CompletedAt;
      if (completedAt) {
        const startDate = new Date(completedAt);
        let nextDate = new Date(startDate);

        if (type === "DAY") {
          nextDate.setDate(nextDate.getDate() + count);
        } else if (type === "WEEK") {
          nextDate.setDate(nextDate.getDate() + count * 7);
        } else if (type === "MONTH") {
          nextDate.setMonth(nextDate.getMonth() + count);
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (nextDate < today) {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          tomorrow.setHours(0, 0, 0, 0);
          nextDate = tomorrow;
        }

        const formattedDate = nextDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric"
        });

        const formatDateForAPI = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const apiDate = formatDateForAPI(nextDate);

        const showModal = () => {
          const modal = document.createElement("div");
          modal.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10000;
          `;

          modal.innerHTML = `
            <div style="background: white; padding: 30px; border-radius: 10px; max-width: 500px; text-align: center;">
              <h3 style="margin-bottom: 20px;">Update Next Billing Date?</h3>
              <p style="margin-bottom: 30px;">Would you like to also update your next billing date to <strong>${formattedDate}</strong>?</p>
              <div style="display: flex; gap: 15px; justify-content: center;">
                <button id="nbd-yes" style="padding: 10px 30px; background: #3700ff; color: white; border: none; border-radius: 5px; cursor: pointer; font-weight: bold;">Yes</button>
                <button id="nbd-no" style="padding: 10px 30px; background: #ccc; color: #333; border: none; border-radius: 5px; cursor: pointer; font-weight: bold;">No</button>
              </div>
            </div>
          `;

          document.body.appendChild(modal);

          document.getElementById("nbd-yes").addEventListener("click", async () => {
            console.log("User clicked Yes - Update NBD to:", nextDate);

            const apiUrl = `https://shapi.bundlepayments.com/customers/${customerId}/subscriptions/${subscriptionId}/next-billing-date`;

            try {
              const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  authorization: capturedAuthToken
                },
                body: JSON.stringify({
                  nextBillingDate: apiDate,
                  eventType: "UPDATED_ORDER_DATE"
                })
              });

              const responseText = await response.text();
              console.log("NBD API response:", response.status, responseText);

              if (response.ok) {
                console.log("NBD updated successfully, reloading...");
              } else {
                console.error("Failed to update NBD:", response.status);
              }

              debugger;
              window.location.reload();
            } catch (error) {
              console.error("Error updating NBD:", error);
              window.location.reload();
            }
          });

          document.getElementById("nbd-no").addEventListener("click", () => {
            console.log("User clicked No - No change to NBD");
            document.body.removeChild(modal);
          });
        };

        showModal();
      }
    }
  };

  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      const match = url.match(frequencyApiPattern);

      if (match) {
        const customerId = match[1];
        const subscriptionId = match[2];
        const authToken = args[1]?.headers?.authorization || args[1]?.headers?.Authorization;

        return originalFetch(...args).then((response) => {
          response
            .clone()
            .json()
            .then((data) => {
              handleFrequencyApiCall(customerId, subscriptionId, data, authToken);
            })
            .catch(() => {
              handleFrequencyApiCall(customerId, subscriptionId, {}, authToken);
            });
          return response;
        });
      }

      return originalFetch(...args);
    };
  }




  //disable skip and nbd edit if skipped
  const skipApiPattern = /https:\/\/shapi\.bundlepayments\.com\/customers\/\d+\/subscriptions\/\d+\/skip/;

  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

      return originalFetch(...args).then((response) => {
        if (skipApiPattern.test(url) && response.ok) {
          document.body.classList.add("hideSkipAndNBD");
        }
        return response;
      });
    };
  }

  const checkSkippedAttribute = () => {
    const customAttributes = window.Awtomic?.subscriptionDetails?.CustomAttributes;
    if (customAttributes) {
      const skippedAttr = customAttributes.find((attr) => attr.key === "skipped" && attr.value === "true");
      if (skippedAttr) {
        document.body.classList.add("hideSkipAndNBD");
      }
    }
  };

  window.addEventListener("awtomic-cp-loaded", checkSkippedAttribute);
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);
  }
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});
